import { type Team, type TeamRole } from "@repo/api";

export const getRole = (
  allTeams: Team[],
  selectedId: number,
  userEmail?: string | null,
  isDevOrSuperUser?: boolean
): TeamRole | undefined => {
  if (!userEmail) {
    return undefined;
  }

  if (isDevOrSuperUser) {
    return "MANAGER";
  }

  const normalizedEmail = userEmail.toLowerCase();

  const selectedTeam = allTeams.find((team) => team.teamId === selectedId);
  if (!selectedTeam) {
    return undefined;
  }

  if (selectedTeam.manager.emailId.toLowerCase() === normalizedEmail) {
    return "MANAGER";
  } else if (
    selectedTeam.teamMembers.find(
      (member) => member.emailId.toLowerCase() === normalizedEmail
    )
  ) {
    return "MEMBER";
  } else {
    return "VISITOR";
  }
};
